import type { Role } from "@prismicio/editor-fields"

export const settingsPermission: Record<Role, boolean> = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Publisher: false,
  Writer: false,
  Contributor: false,
}

export const publisherPermission: Record<Role, boolean> = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Publisher: true,
  Writer: false,
  Contributor: false,
}

export const teamSpaceManagementPermission: Record<Role, boolean> = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Publisher: false,
  Writer: false,
  Contributor: false,
}
